<template>
    <v-dialog v-model="isOpen" max-width="550px" scrollable persistent>
      <v-card>
        <v-card-title class="dialog-title">
          <span>{{ this.dialogTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container class="dialog-container">
            <v-row class="d-flex mt-5 justify-end"  v-if="hasState">
              <ul class="tooltip-list">
                <li class="not-started">Not Started</li>
                <li class="in-progress">In Progress</li>
                <li class="completed-course">Completed</li>
              </ul>
            </v-row>
              <v-row v-if="hasState">
                <ul class="grid-list course-list" >
                  <li v-for="(item, index) in this.dialogData" :key="index" :class="getStateIcon(item.state)">
                    {{ item.name }}
                  </li>
                </ul>
              </v-row>
              <v-row v-else>
                <ul class="grid-list">
                  <li  v-for="(item,index) in this.dialogData" :key="index"> {{ item }} </li> 
                  </ul>
              </v-row>
            </v-container>
        </v-card-text>
        <v-card-actions class="btn-section">
          <v-btn class="mr-1 mb-2 add-course-button"
          color="primary" outlined @click="closeDialog">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>


<script>
export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    dialogTitle: {
      type: String,
      required: true
    },
    dialogData: {
      type: Array,
      required: true
    }
  },
  computed: {
   hasState() {
    return this.dialogData.some(item => 
      typeof item === 'object' && item !== null && 'state' in item
    )
  }
  },
  methods: {
    closeDialog() {
      this.$emit('close');
    },

    getStateIcon(state){
        switch(state){
          case 1:
            return 'not-started'   
          case 3:
            return 'completed-course'
          default:
            return  'in-progress'
        }
    }
  }
};
</script>

<style scoped>
/* ===== Legend (top status list) ===== */
.tooltip-list {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 18px;
  list-style: none;
  padding: 0;
  margin: 0 0 10px 6px;
}

.tooltip-list li {
  position: relative;
  padding-left: 26px;
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
}

.tooltip-list li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  border-radius: 50%;
}

.course-list{
  list-style: none;
}

/* ===== Grid Layout ===== */
.course-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 40px;
  row-gap: 18px;
  width: 100%;
  padding: 10px 6px 0;
  margin: 0;
  align-items: start;
}

/* Mobile */
@media (max-width: 600px) {
  .grid-list {
    grid-template-columns: 1fr;
    row-gap: 14px;
  }
}

/* ===== Course Item ===== */
.course-list li {
  position: relative;
  padding-left: 36px;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.4;
  word-break: break-word;
}

/* Base circle */
.course-list li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  border-radius: 50%;
}

/* ===== Status Styles ===== */

/* Not Started */
.not-started::before {
  border: 2px solid var(--v-primary-base);
  background: #fff;
}

/* Completed */
.completed-course::before {
  background: #22c55e;
}

.completed-course::after {
  content: "✓";
  position: absolute;
  left: 5px;
  top: 50%;
  transform: translateY(-55%);
  color: #fff;
  font-size: 13px;
  font-weight: bold;
}

/* In Progress (animated spinner) */
.in-progress::before {
  border: 3px solid #ffaf19;
  border-top-color: transparent;
  background: transparent;
}

/* ===== Button Section ===== */
.btn-section {
  justify-content: center;
  padding-bottom: 14px;
}

.add-course-button {
  min-width: 110px;
  font-weight: 600;
  letter-spacing: 0.4px;
}

/* ===== Dialog responsiveness ===== */
@media (max-width: 600px) {
  .course-list li {
    font-size: 14px;
    padding-left: 32px;
  }
}
</style>